import React, { PureComponent } from 'react';

import * as Sentry from '@sentry/browser';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { ErrorMessage } from './error-message';

const styles = () => ({
  header: {
    margin: 'auto',
    width: '100%',
    maxWidth: 800,
    lineHeight: 1,
    paddingRight: '16px',
    paddingLeft: '16px',
    marginTop: '25px',
    marginBottom: '8px',
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    margin: 'auto',
    padding: 24,
    maxWidth: 800,
    width: '100%',
  },
});

type Props = { children: any; classes: Record<string, any> };
type State = { hasError: boolean };

export class ErrorBoundaryComponent extends PureComponent<Props, State> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  componentDidCatch(error: Error, errorInfo: any) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
      this.setState({ hasError: true });
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.hasError) {
      return (
        <div className={classes.root}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            className={classes.header}
            justifyContent="space-between"
          >
            <Grid item xs={12}>
              <Paper elevation={3} className={classes.paper}>
                <Typography variant="h4">Error</Typography>
                <hr />
                <ErrorMessage />
              </Paper>
            </Grid>
          </Grid>
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withStyles(styles)(ErrorBoundaryComponent);
